import React from 'react';
import { View , Image} from 'react-native';
import { ActivityIndicator } from 'react-native-paper';

export default function SplashScreen() {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center',backgroundColor:'#ebebeb' }}>

        <Image style={{ height: 40 ,width:180,marginTop:50 }} resizeMode='contain' source={require('../assets/img/logotype.png')}/>
        <ActivityIndicator style={{marginTop:100}} animating={true} color='#21706c' />
        
      </View>
    );
  }